import React from 'react';
import ReactDOM from 'react-dom';
import { Initializer } from 'common/types/initializers';
import App from 'common/backbone-app';
import Wahanda from 'common/wahanda';
import { SideBarAnalytics } from 'common/analytics';
import { Reconnect } from 'src/federation/Reconnect';
import { openChat } from 'utilities/support-chat';
import { phoneSupportUrl, referSalonUrl } from 'utilities/support-links';

interface Params {
  node: HTMLElement;
  triggerElement?: HTMLElement | null;
}

const LIVE_CHAT_SOURCE = 'header help menu';

type HelpMenuItem = 'refer-salon' | 'help-centre' | 'whats-new' | 'chat-support';

const trackHelpMenuItem: Record<HelpMenuItem, () => void> = {
  'refer-salon': () => SideBarAnalytics.trackReferSalonClick(),
  'help-centre': () => SideBarAnalytics.trackHelpCenterClick(),
  'whats-new': () => SideBarAnalytics.trackWhatsNewClick({ property: LIVE_CHAT_SOURCE }),
  'chat-support': () => SideBarAnalytics.trackGetHelpClick(),
};

export const HelpMenuInitializer = ({ node, triggerElement }: Params): Initializer => ({
  destroy: () => {
    ReactDOM.unmountComponentAtNode(node);
  },
  render: () => {
    if (!triggerElement) {
      return;
    }

    const contacts = Wahanda.lang.home.contacts;
    const account = App.config.get('account');

    ReactDOM.render(
      <Reconnect
        name="HelpMenu"
        props={{
          referSalonUrl: referSalonUrl({
            venueId: App.getVenueId(),
            venueName: App.config.accountEmployeeName() || App.config.accountFullName(),
            emailAddress: account.emailAddress,
            accountId: App.config.getAccountId(),
          }),
          helpCentreUrl: contacts.helpCenterUrl,
          phoneSupportUrl: phoneSupportUrl(),
          showWhatsNew: Boolean(App.isProductFruitsInitialized),
          externalTrigger: triggerElement,
          onChatSupportClick: () => openChat(LIVE_CHAT_SOURCE),
          onItemClick: (item) => {
            trackHelpMenuItem[item]();
          },
        }}
      />,
      node,
    );
  },
});
